import { render, staticRenderFns } from "./product_classify.vue?vue&type=template&id=73b1f3dd&scoped=true"
import script from "./product_classify.vue?vue&type=script&lang=js"
export * from "./product_classify.vue?vue&type=script&lang=js"
import style0 from "./product_classify.vue?vue&type=style&index=0&id=73b1f3dd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b1f3dd",
  null
  
)

export default component.exports